export default __webpack_public_path__ + "static/media/spinner.c3b0fbd4.svg";